export function authentified() {
    return srv => srv.authentified();
}


